import { render, staticRenderFns } from "./application-sync-status-badge.vue?vue&type=template&id=45798c20"
import script from "./application-sync-status-badge.vue?vue&type=script&lang=ts"
export * from "./application-sync-status-badge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports